import {
  Box,
  Button,
  Circle,
  Flex,
  Heading,
  HStack,
  Text,
} from "@chakra-ui/react";
import { brandPalette } from "../../../../constants/brandPalette";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import MainModel from "../../../../components/Models/main-model";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
} from "../../../../components/Models/admin-modal-theme";
import { getAllChaptersRequest } from "../../../../modules/admin-modules/chapters/Actions";
import {
  createExamRequest,
  editExamRequest,
} from "../../../../modules/admin-modules/exams/Actions";
import { getAllGroupsRequest } from "../../../../modules/admin-modules/groups/Actions";
import {
  closeCreateExamDataModel,
  openQuestionsListModel,
} from "../../../../modules/admin-modules/models/Actions";
import { getAllVideosRequest } from "../../../../modules/admin-modules/videos/Actions";
import StepOne from "../forms/step-one";
import StepTwo from "../forms/step-two";

/** API datetime → value for input[type=datetime-local] */
function apiDateToDatetimeLocal(val) {
  if (val == null || val === "") return "";
  const s = String(val).trim();
  const m = s.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})(:\d{2})?/);
  if (m) return `${m[1]}T${m[2]}`;
  const d = new Date(s);
  if (!Number.isNaN(d.getTime())) {
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
  return "";
}

/** datetime-local → Laravel-friendly "Y-m-d H:i:s" */
function datetimeLocalToApi(val) {
  if (val == null || String(val).trim() === "") return null;
  const raw = String(val).trim();
  const withSeconds = raw.length === 16 ? `${raw}:00` : raw;
  return withSeconds.replace("T", " ");
}

const AddExamData = ({ isAdd, data, setSelectedData, setExamData }) => {
  const [isFormOne, setFormOne] = useState(true);

  const openExamData = useSelector((state) => state.model.isOpen15);
  const chapters = useSelector((state) => state.chapters.chapters);
  const groups = useSelector((state) => state.groups.groups);
  const isLoading = useSelector((state) => state.chapters.isLoading);

  const dispatch = useDispatch();
  useEffect(() => {
    if (openExamData) {
      if (chapters?.length == 0) dispatch(getAllChaptersRequest());
      if (groups?.length == 0) dispatch(getAllGroupsRequest());
      // dispatch(getPerformanceGroupsRequest());
      dispatch(getAllVideosRequest());
    }
  }, [openExamData]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: { time: "0" },
    shouldUnregister: true,
  });

  useEffect(() => {
    if (!openExamData) return;

    setFormOne(true);

    if (!isAdd && data?.id) {
      reset({
        ...data,
        time: data?.time ?? "0",
        question_number: data?.question_number,
        start_time: apiDateToDatetimeLocal(data?.start_time),
        end_time: apiDateToDatetimeLocal(data?.end_time),
      });

      const groupIds = (data?.groups || []).map((g) => g?.id ?? g);
      setValue("groups", groupIds);

      (data?.chapters || []).forEach((ch, idx) => {
        const i = idx + 1;
        setValue(`chapters[${i}][chapter_id]`, ch?.id ?? ch?.chapter_id);
        setValue(
          `chapters[${i}][no_of_questions]`,
          ch?.pivot?.no_of_questions ?? ch?.no_of_questions ?? 0
        );
      });

      (data?.exam_tags || []).forEach((tag, idx) => {
        const i = idx + 1;
        setValue(
          `exam_tags[${i}][question_tag_id]`,
          tag?.question_tag_id ?? tag?.tag_id ?? tag?.id
        );
        setValue(
          `exam_tags[${i}][question_number]`,
          tag?.question_number ?? tag?.no_of_questions ?? 0
        );
      });
    } else {
      reset({ time: "0" });
    }
  }, [openExamData, isAdd, data?.id, reset, setValue]);

  const watchSubType = watch("sub_type") || data?.sub_type;
  const watchTotalQustions = watch("question_number") || data?.question_number;
  const watchChapters = watch("chapters") || data?.chapters;
  const watchExamTags = watch("exam_tags") || data?.exam_tags;
  const watchTimer = watch("timer") || data?.timer;
  const watchQuestionWay = watch("random") || data?.random;
  const watchType = watch("type") || data?.type;

  const header = (
    <Box>
      <Heading
        fontSize="32px"
        fontWeight="800"
        color={brandPalette.primary}
        fontFamily="'Amiri','Tajawal',sans-serif"
      >
        {isAdd ? "Add Assignment" : "Edit Assignment"}
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="var(--text-muted)"
        textTransform="uppercase"
        letterSpacing="0.14em"
        fontWeight="700"
      >
        Two steps: assignment settings, then question selection rules
      </Text>
    </Box>
  );

  const onSubmit = async (values) => {
    const totel = {
      ...data,
      ...values,
      start_time: datetimeLocalToApi(values?.start_time),
      end_time: datetimeLocalToApi(values?.end_time),
    };

    let formData = new FormData();
    let chapters = [];
    for (let key in totel) {
      if (key == "groups") {
        totel[key]?.map((val, idx) =>
          formData.append(`groups[${idx}]`, val?.id ? val?.id : val)
        );
      } else if (key == "chapters") {
        let primaryChapterSet = false;
        totel[key]?.map((val, idx) => {
          if (!val) return;
          if (val) chapters.push(val);
          const isPrimary =
            Number(totel.sub_type) === 2 && !primaryChapterSet;
          if (isPrimary) primaryChapterSet = true;
          formData.append(
            `chapters[${idx}][chapter_id]`,
            val.id ? val.id : val?.chapter_id
          );
          formData.append(
            `chapters[${idx}][no_of_questions]`,
            Number(totel.sub_type) === 4 || isPrimary
              ? 0
              : val.no_of_questions ??
                val.pivot?.no_of_questions ??
                totel?.question_number
          );
        });
      } else if (key == "exam_tags" && Number(totel.sub_type) === 4) {
        totel[key]?.map((val, idx) => {
          if (!val) return;
          formData.append(
            `exam_tags[${idx}][question_tag_id]`,
            val.question_tag_id ? val.question_tag_id : val?.tag_id ?? val?.id
          );
          formData.append(
            `exam_tags[${idx}][question_number]`,
            val.question_number
              ? val.question_number
              : val.no_of_questions ?? totel?.question_number
          );
        });
      } else if (key === "start_time") {
        if (totel.start_time != null) {
          formData.append("start_time", totel.start_time);
        }
      } else if (key === "end_time") {
        if (totel.end_time != null) {
          formData.append("end_time", totel.end_time);
        }
      } else if (key !== "exam_tags" && totel[key]) {
        formData.append(key, totel[key]);
      }
    }
    if (totel["timer"] == 0) {
      formData.append("time", 0);
    }
    const action = (data) => {
      dispatch(closeCreateExamDataModel());
      setSelectedData({});
      reset();
      setFormOne(true);

      setExamData({
        chapter_id: chapters?.[0]?.chapter_id,
        exam: data?.id,
        question_number: data?.question_number,
      });
      isAdd && watchQuestionWay == 0 && dispatch(openQuestionsListModel());
    };
    if (isAdd) {
      dispatch(createExamRequest(formData, action));
    } else {
      formData.append("_method", "PUT");

      dispatch(
        editExamRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateExamDataModel());
    setSelectedData({});
    reset();
    setFormOne(true);
  };

  useEffect(() => {
    if (watchQuestionWay == 0) setValue("sub_type", 2);
  }, [watchQuestionWay]);
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openExamData}
      buttonTitle={null}
      buttonFunc={handleSubmit(onSubmit)}
      size="5xl"
      contentProps={{ ...adminModalContentProps, overflow: "visible" }}
      headerProps={adminModalHeaderProps}
      bodyProps={{ ...adminModalBodyProps, overflow: "visible" }}
      hideDefaultFooter
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <HStack dir="ltr" w="100%" justifyContent="center" spacing="50px" mb={6}>
          <HStack onClick={() => setFormOne(true)} cursor="pointer">
            <Circle
              size="40px"
              bg={isFormOne ? brandPalette.primary : "var(--surface-muted)"}
              color={isFormOne ? "white" : brandPalette.primary}
              borderColor={brandPalette.primary}
              border="1px solid"
            >
              1
            </Circle>
            <Text fontWeight="700" color="var(--text-primary)">
              Assignment details
            </Text>
          </HStack>
          <HStack onClick={() => setFormOne(false)} cursor="pointer">
            <Circle
              size="40px"
              bg={!isFormOne ? brandPalette.primary : "var(--surface-muted)"}
              color={!isFormOne ? "white" : brandPalette.primary}
              borderColor={brandPalette.primary}
              border="1px solid"
            >
              2
            </Circle>
            <Text fontWeight="700" color="var(--text-primary)">
              Questions
            </Text>
          </HStack>
        </HStack>

        {/* first form */}
        <StepOne
          key={data?.id ? `exam-step1-${data.id}` : "exam-step1-new"}
          data={data}
          register={register}
          watchTimer={watchTimer}
          errors={errors}
          isFormOne={isFormOne}
          watchType={watchType}
          setValue={setValue}
          isAdd={isAdd}
        />
        {/* form two */}
        <StepTwo
          key={data?.id ? `exam-step2-${data.id}` : "exam-step2-new"}
          watchSubType={watchSubType}
          watchTotalQustions={watchTotalQustions}
          watchQuestionWay={watchQuestionWay}
          data={data}
          setValue={setValue}
          register={register}
          errors={errors}
          isFormOne={isFormOne}
          watchChapters={watchChapters}
          watchExamTags={watchExamTags}
          isAdd={isAdd}
        />
        <Flex
          mt={8}
          flexDir={{ base: "column", sm: "row" }}
          align={{ base: "stretch", sm: "center" }}
          justify="space-between"
          gap={4}
        >
          <Button
            onClick={() => setFormOne(!isFormOne)}
            color="white"
            bg={brandPalette.primary}
            _focus={{ outline: "none" }}
            minW="200px"
            borderRadius="lg"
            fontWeight="800"
            _hover={{ bg: brandPalette.accentDark }}
          >
            {isFormOne ? "Next step" : "Previous step"}
          </Button>
          <Flex justify="flex-end" gap={6} flexWrap="wrap">
            <Button
              variant="ghost"
              color="var(--text-primary)"
              fontWeight="800"
              _hover={{ textDecoration: "underline", bg: "rgba(91, 13, 22, 0.08)" }}
              onClick={closeFunc}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              bg={brandPalette.primary}
              color="white"
              borderRadius="lg"
              px={8}
              py={6}
              fontWeight="800"
              isLoading={isLoading}
              _hover={{ bg: brandPalette.accentDark }}
              boxShadow="0 10px 24px rgba(91, 13, 22, 0.18)"
            >
              Save Changes
            </Button>
          </Flex>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddExamData;
